import React from 'react';

import { FailedCartItem } from 'src/hooks/cart-restoration-utils';
import { withModalControlsHook, ModalComponentProps } from 'src/components/modals/with-modal-controls-hook';
import { ModalWrapper } from 'shared/modals/v2-wrapper';

import { ModalContainer } from 'src/components/core';
import { ModalExitIcon } from 'shared/modals/v2-container';
import useUI from 'src/hooks/use-ui';
import { ItemsUnavailable as ItemsUnavailableComponent } from './items-unavailable';

export type ItemsUnavailableDataType = {
  failedCartItems: FailedCartItem[];
};

type ItemsUnavailableModalProps = ModalComponentProps<ItemsUnavailableDataType>;

const ItemsUnavailableModal = ({
  onClose: closeModal,
  containerProps,
  data,
}: ItemsUnavailableModalProps): JSX.Element => {
  const ui = useUI();
  const handleClose = (): void => {
    closeModal();
    ui.openCartDrawer();
  };

  return (
    <>
      <ModalWrapper onClose={handleClose} open>
        <ModalContainer width={465} padding={32} {...containerProps}>
          <ModalExitIcon onClick={handleClose} />
          <ItemsUnavailableComponent close={handleClose} data={data} />
        </ModalContainer>
      </ModalWrapper>
    </>
  );
};

const [ItemsUnavailable, useItemsUnavailableModal] = withModalControlsHook<ItemsUnavailableDataType>(
  ItemsUnavailableModal
);

export { useItemsUnavailableModal, ItemsUnavailable };
